import { ThemeOptions } from '@mui/material';

import { capitalCategoricalPalette } from '../../capitalCategoricalPalette';

// v8.28.2's published `ChartsComponents` interface omits `MuiRadarChart` even
// though `RadarChart` calls `useThemeProps({ name: 'MuiRadarChart' })` at
// runtime, so we declare the slot ourselves. Typed inline (not via
// `RadarChartProps`) to keep `@mui/x-charts` out of the shipped d.ts —
// consumers who don't render charts don't need it installed for type checking.
// No Theme type parameter: the parameter is unused, and naming it fails the unused-var lint.
// Declaration merging still matches MUI's `interface Components<Theme = unknown>`.
declare module '@mui/material/styles' {
  interface Components {
    MuiRadarChart?: {
      defaultProps?: {
        colors?: readonly string[];
        enableKeyboardNavigation?: boolean;
      };
    };
  }
}

export const MuiRadarChart: NonNullable<ThemeOptions['components']>['MuiRadarChart'] = {
  defaultProps: {
    colors: capitalCategoricalPalette,
    enableKeyboardNavigation: true
  }
};
